import moment from 'moment';
import _ from 'lodash';

export default function (date, calendarConfig) {
  if (_.isString(date)) {
    date = moment(date, 'YYYY-MM-DD HH:mm:ss').toDate();
  } else {
    date = new Date(date);
  }

  const dayDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
  let isWorkDay = true;

  if (!calendarConfig) {
    return isWorkDay;
  }

  const workDates = calendarConfig.dates;
  const day = date.getDay();

  const isCustomDay = _.find(workDates, (value, key) => {
    if (key.length < 2 || dayDate !== +key) {
      return false;
    }

    return true;
  });

  if (_.isUndefined(isCustomDay)) {
    isWorkDay = !!workDates[day];
  } else {
    isWorkDay = !!isCustomDay;
  }

  return isWorkDay;
}
